import { gql } from '@apollo/client'

import { SIMPLE_ALLERGEN_FRAGMENT } from '../fragments'

const SET_IS_CURATION_ENABLED_ALLERGEN_MUTATION = gql`
  mutation setIsCurationEnabledAllergen(
    $id: ID!
    $isCurationEnabled: Boolean!
  ) {
    setIsCurationEnabledAllergen(
      id: $id
      isCurationEnabled: $isCurationEnabled
    ) {
      ...SimpleAllergenFragment
    }
  }
  ${SIMPLE_ALLERGEN_FRAGMENT}
`

export default SET_IS_CURATION_ENABLED_ALLERGEN_MUTATION
